export const getComparisonResultClass = (result) => {
	switch (result) {
		case "Match":
			return "resultMatch";
		case "Within Tolerance":
			return "resultTolerance";
		case "Does Not Match":
			return "resultMismatch";
		case "Missing":
			return "resultMissing";
		case "Unable to Validate":
			return "resultUnable";
		default:
			return "resultNeutral";
	}
};

export const getValidationStatusShortLabel = (status) => {
	if (status === "Missing in TeleTrace") return "Missing";
	return status;
};
